import { pickT } from "@repo/shared";
import type { ProductCostsSource } from "@repo/shared/types";
import { ProductCostsSourceSelect } from "@/components/product-costs-source-select";
import { T } from "./settings-product-costs-form.i18n";

type SettingsProductCostsFormProps = {
  flowLanguage: string;
  portfolioSource: ProductCostsSource;
  onPortfolioSourceChange: (source: ProductCostsSource) => void;
};

export function SettingsProductCostsForm({
  flowLanguage,
  portfolioSource,
  onPortfolioSourceChange,
}: SettingsProductCostsFormProps) {
  return (
    <ProductCostsSourceSelect
      language={flowLanguage}
      value={portfolioSource}
      onChange={onPortfolioSourceChange}
      hint={pickT(T, flowLanguage).portfolioSourceDesc}
    />
  );
}
